export default __webpack_public_path__ + "static/media/LINE_spinner_light.3e85f802.svg";